import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

import { ref, shallowRef, watchEffect } from 'vue'
import TaskAttachment from '../TaskAttachment.vue'
import { isNative } from '../../utils'
import { Table } from '../../types/components/data-rendering'
import { useTaskProfiles } from '../../store/useTaskProfiles'
import { storeToRefs } from 'pinia'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import FetchPdf from '../FetchPdf.vue'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'

export default /*#__PURE__*/_defineComponent({
  __name: 'TasksIndex',
  setup(__props) {

const loading = ref(true)
const data = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    const { taskIndex } = storeToRefs(useTaskProfiles())
    data.value = taskIndex.value
    loading.value = false
  },
  { flush: 'post' }
)

const isFetching = ref(false)
const setFetching = (e: any) => (isFetching.value = e)
const { taskListDisplayOptions } = useFilteringDisplayOptions({
  isFetching,
})

return (_ctx: any,_cache: any) => {
  return (data.value)
    ? (_openBlock(), _createBlock(FilteringDataDisplay, {
        key: `taskIndex-${loading.value}`,
        "is-loading": loading.value,
        "table-data": data.value,
        "display-type": _ctx.displayType,
        options: _unref(taskListDisplayOptions)
      }, _createSlots({
        attachment: _withCtx(({ rowData, filterData }) => [
          (_openBlock(), _createBlock(TaskAttachment, {
            key: JSON.stringify(rowData['attachment']),
            truncate: "",
            attachment: rowData['attachment'],
            "filter-data": filterData
          }, null, 8, ["attachment", "filter-data"]))
        ]),
        _: 2
      }, [
        (_unref(isNative))
          ? {
              name: "actions",
              fn: _withCtx(({ checkedData }) => [
                _createVNode(FetchPdf, {
                  data: checkedData,
                  field: "attachment",
                  onIsFetching: setFetching
                }, null, 8, ["data"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["is-loading", "table-data", "display-type", "options"]))
    : _createCommentVNode("", true)
}
}

})